import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import {
  getMaintenancePlanGroup,
  getMaintenancePlanGroups,
} from "../services/maintenance-plan-group";

export function useGetMaintenancePlanGroups() {
  return useQuery({
    queryKey: ["maintenancePlanGroups"],
    queryFn: () => getMaintenancePlanGroups(),
    staleTime: 1000 * 60 * 5,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetMaintenancePlanGroup(id: string) {
  return useQuery({
    queryKey: ["maintenancePlanGroup", id],
    queryFn: () => getMaintenancePlanGroup(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
